import type { ReactNode } from "react";
import { Provider } from "react-redux";

import { store } from "../../store";
import { AuthProvider } from "./AuthContext";
import { RestaurantDetailsProvider } from "./RestaurantDetailsContext";
import { OrderFlowProvider } from "./OrderFlowProvider";

const AppProviders = ({ children }: { children?: ReactNode }) => {
    return (
        <Provider store={store}>
            <AuthProvider>
                <RestaurantDetailsProvider>
                    <OrderFlowProvider>
                        {children}
                    </OrderFlowProvider>
                </RestaurantDetailsProvider>
            </AuthProvider>
        </Provider>
    );
};

export default AppProviders;
